<mat-drawer-container class="vanta-data__viewer-container">
  <mat-drawer class="sidemenu" #sidenav [mode]="sideBarMode" [opened]="isOpen" [autoFocus]="false">
    <div  class="vanta-data__viewer-search">
      <mat-accordion >
        <mat-expansion-panel class="filter-panel" #filterControls>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'dataViewer.filteringOptions' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form fxLayout="column" fxFlex="1 1 auto" fxLayoutGap="5px" (ngSubmit)="onSubmit(searchForm.value)" autocomplete="off" [formGroup]="searchForm" class="data__search--container">
              <div fxFlex="1 1 100%">
                  <div class="date-row">
                      <mat-form-field class="date-field-inline">
                          <mat-label>Start Date</mat-label>
                          <input matInput
                                 [matDatepicker]="startPicker"
                                 formControlName="startDate"
                                 (dateChange)="validDateRange()">
                          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                          <mat-datepicker #startPicker></mat-datepicker>
                      </mat-form-field>
                      <mat-form-field class="date-field-inline">
                          <mat-label>End Date</mat-label>
                          <input matInput
                                 [matDatepicker]="endPicker"
                                 [min]="searchForm.get('startDate')?.value"
                                 formControlName="endDate"
                                 (dateChange)="validDateRange()">
                          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                          <mat-datepicker #endPicker></mat-datepicker>
                      </mat-form-field>
                  </div>
                  <div fxFlex="1 1 auto" fxLayout="column" class="scroll-section" data-simplebar data-simplebar-auto-hide="false">
                      <mat-selection-list dense #selectSerialNumber formControlName="serialNumbers" (selectionChange)="onSerialNumberSelected($event)">
                          <h3 mat-subheader>Devices</h3>
                          <mat-list-option *ngFor="let device of serialNumbers" [value]="device.id" checkboxPosition="before">
                              {{device.name}}
                          </mat-list-option>
                      </mat-selection-list>
                  </div>
                  <mat-error fxFlex="1 1 auto">
                      <span *ngIf="error.isError">{{error.errorMessage}}</span>
                  </mat-error>
              </div>
              <evc-button text="Load data" type="primary" [disabled]="error.isError || !devicesSelected" [fullWidth]="true" />
          </form>
        </mat-expansion-panel>
      </mat-accordion>
      <div fxLayout="row">        
          <div fxFlex="1 1 auto" fxLayout="column" *ngIf="!searching; else spinner">
              <div class="results-panel">
                  <div class="vanta-data__results-header" *ngIf="treeDataSource && treeDataSource.data.length > 0">
                      <div>
                          <span class="vanta-data__results-title">{{ 'dataViewer.results' | translate }} </span>
                          <span class="vanta-data__results-count" *ngIf="selectedShotsCount !== 0"> &nbsp;({{selectedShotsCount}}) </span>
                      </div>
                      <span *ngIf="treeDataSource && treeDataSource.data.length>0" class="float-button">
                          <button color="primary" mat-icon-button [disabled]="selectedShotsCount === 0" [matMenuTriggerFor]="exportFileMenu" title="Export">
                              <evc-icon icon="file-export"></evc-icon>
                          </button>
                          <span class="divider"></span>
                          <button color="primary" mat-icon-button [disabled]="selectedShotsCount === 0" title="Delete" (click)="deleteVantaShots()">
                              <evc-icon icon="trash-delete"></evc-icon>
                          </button>
                          <mat-menu #exportFileMenu="matMenu">
                              <button mat-menu-item (click)="exportVantaShotCSV()">Export CSV</button>
                              <button mat-menu-item (click)="exportVantaShotJSON()">Export JSON</button>
                          </mat-menu>
                      </span>
                  </div>
                  <mat-tree [dataSource]="treeDataSource" [treeControl]="treeControl" class="simple-tree">
                      <!-- This is the tree node template for leaf nodes -->
                      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="36">
                          <li class="mat-tree-node mat-leaf-node">
                              <mat-checkbox class="checklist-leaf-node"
                                            [checked]="checklistSelection.isSelected(node)"
                                            (change)="leafItemSelectionToggle(node)">{{node.item}}</mat-checkbox>
                              <button mat-button (click)="onSelectResult(node)"
                                      [ngClass]="{ 'background-highlight': activeNode === node.id }">
                                  <span class="simple-tree__serial-number">{{node.value.tidName}}</span> [{{node.value.serialNumber}}] >
                              </button>
                          </li>
                      </mat-tree-node>
                      <!-- This is the tree node template for expandable nodes -->
                      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="36">
                          <li>
                              <div class="mat-tree-node">
                                  <mat-checkbox [checked]="descendantsAllSelected(node)"
                                                [indeterminate]="descendantsPartiallySelected(node)"
                                                (change)="itemSelectionToggle(node)">{{node.item}}</mat-checkbox>
                                  <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                      <mat-icon class="mat-icon-rtl-mirror">
                                          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                      </mat-icon>
                                  </button>
                                  <button mat-button (click)="onSelectNoneResultNode(node)"
                                          [ngClass]="{ 'background-highlight': activeNode === node.id }">
                                      {{node.name}}
                                  </button>
                              </div>
                              <ul [class.simple-tree-invisible]="!treeControl.isExpanded(node)">
                                  <ng-container matTreeNodeOutlet></ng-container>
                              </ul>
                          </li>
                      </mat-tree-node>
                  </mat-tree>
              </div>
          </div>
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content>
      <button fxHide fxShow.lt-md
              mat-icon-button
              (click)="sidenav.toggle()"
              class="expand-button small-btn">
          <mat-icon>{{ sidenav.opened ? 'chevron_left' : 'chevron_right' }}</mat-icon>
      </button>
      <div class="vanta-data__viewer-manager">
          <app-vanta-shot-result #shotResult [searchResultItem]="selectedResultItems" [searching]="!firstSearch && !activeNode"></app-vanta-shot-result>
      </div>
  </mat-drawer-content>
</mat-drawer-container>
<ng-template #spinner>
  <div class="d-flex justify-content-center spinner-container">
      <div class="spinner-grow spinner-grow--olympus-blue" role="status">
      <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow spinner-grow--olympus-blue" role="status">
      <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow spinner-grow--olympus-blue" role="status">
      <span class="sr-only">Loading...</span>
      </div>
  </div>
</ng-template>